import React, { useRef, useState } from 'react';
import styles from './AdminMobileNoticeRegister.module.css';
import { textFormat } from "InitialData/regExp";
import Container from 'layouts/container/Container';
import { mainBgColor, mainPadd, pageCommonGap1, pageCommonPadd2, pageH1FontSize, registerFontSize, registerGap1, registerGap2, registerHeight } from '../constraints/AdminConst';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import useCustomAdminMobileMove from '../hooks/useCustomAdminMobileMove';
import backIcon from 'routes/vendorRe/images/back_icon.png';
import P from 'components/P';
import AdminMobileContentBox from '../components/common/AdminMobileContentBox';
import InputImage from 'components/inputs/image/InputImage';
import InputText from 'components/inputs/signUp/InputText';
import { CButton, CFormInput, CInputGroup, CInputGroupText, CFormSelect } from '@coreui/react';
import { toast } from "react-toastify";
import { validateInputs } from 'shared/utils/Utils';
import { requester } from 'App';
import { useLocation, useNavigate } from "react-router-dom";

// 노출 위치 테스트 데이터
const expoLocation = [
    {
        location: "home",
        locationExp: "홈화면",
    },
    {
        location: "topBanner",
        locationExp: "상단배너",
    },
    {
        location: "bottomBanner",
        locationExp: "하단배너",
    },
];

// 노출 페이지 테스트 데이터
const expoPage = [
    {
        page: "1",
        pageExp: "1 페이지",
    },
    {
        page: "2",
        pageExp: "2 페이지",
    },
    {
        page: "3",
        pageExp: "3 페이지",
    },
];

const formatDate = (isoString) => {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}.${month}.${day} ${hours}시${minutes}분`;
};

const AdminMobileNoticeUpdate = () => {


    const location = useLocation(); // useLocation으로 state 읽기
    const notice = location.state?.notice;


    // const [isMounted, setMounted] = useState(false);
    // useEffect(() => {
    //     setMounted(true);
    // }, [])
    // if (isMounted) {

    // }

    const inputs = useRef([]);
    // const [notice, setNotice] = useState();
    const [selectedExpoLocation, setSelectedExpoLocation] = useState();
    const [selectedExpoPage, setSelectedExpoPage] = useState();
    const [textColor, setTextColor] = useState('#000000'); // 기본 글자색
    const navigate = useNavigate();

    const { moveToBack } = useCustomAdminMobileMove();

    let data = {
        noticeId: "root",
        noticeImg: "",
        noticeTitle: "",
        noticeStartDate: "",
        noticeEndDate: "",
        noticeLocation: selectedExpoLocation === "" ? null : selectedExpoLocation,
        noticePage: selectedExpoPage === "" ? null : selectedExpoPage,
    };

    const handleLocationChange = (event) => {
        // 여기에서 선택된 노출 위치를 사용할 수 있습니다.        
        setSelectedExpoLocation(event.target.value);
    };

    const handlePageChange = (event) => {
        // 여기에서 선택된 노출 페이지를 사용할 수 있습니다.        
        setSelectedExpoPage(event.target.value);
    };

    // 공지사항 등록 버튼 클릭 함수
    const onClick = () => {
        // 초기화 데이터        
        validateInputs(inputs.current).then((result) => {
            if (result.isValid) {
                data.noticeImg = inputs.current[0].getValue();
                data.noticeTitle = inputs.current[1].getValue();
                data.noticeStartDate = inputs.current[2].getValue();
                data.noticeEndDate = inputs.current[3].getValue();

                // validate 이후 데이터 확인

            } else {
                toast.error(`${inputs.current[result.index].getName()} 항목을 확인해주세요`, {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }
        });
    };

    const addNotice = () => {
        let data = {
            title: inputs.current[4].value,
            content: inputs.current[5].value,
        }
        requester.addNotice(data, (result) => {
            if (result.code === 0) {
                navigate('/admin/mobile/notice/');
            }
        });
    }
    const updateNotice = () => {
        let data = {
            id : notice.id,
            title: inputs.current[4].value,
            content: inputs.current[5].value
        }
        requester.updateNotice(data, (result) => {
            if (result.code === 0) {
                navigate('/admin/mobile/notice/');
            }
        })
    }

    return (
        <Container height={registerHeight}>
            <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={pageCommonPadd2}>
                <FlexChild height={"initial"} padding={mainPadd}>
                    <HorizontalFlex>
                        <FlexChild width="auto">
                            <img onClick={() => moveToBack()} className={styles.backIcon} src={backIcon} alt='뒤로 가기 버튼' />
                        </FlexChild>
                        <FlexChild justifyContent="center">
                            {/* H1 헤더 */}
                            <P size={pageH1FontSize}>공지 수정</P>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild padding={mainPadd}>
                    <AdminMobileContentBox flexStart>
                        <VerticalFlex gap={registerGap1}>
                            <FlexChild>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild alignItems="flex-start">
                                        <P size={registerFontSize}>공지 제목</P>
                                    </FlexChild>
                                    {/* <FlexChild>
                                        <InputImage ref={el => (inputs.current[0] = el)} name={"상품 라벨"} path={"product/"} labelWidth={0} cropWidth={200} cropHeight={200} value={notice && notice.image ? notice.image : ""} maxSizeMb={1} />
                                    </FlexChild> */}
                                    <FlexChild alignItems="flex-start">
                                        <FlexChild alignItems="flex-start">
                                            <CFormInput
                                                ref={(el) => (inputs.current[4] = el)}
                                                placeHolder={"공지 제목을 입력하세요."}
                                                defaultValue={notice?.title || ""} 
                                            />
                                        </FlexChild>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                            {/* <FlexChild>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild alignItems="flex-start">
                                        <P size={registerFontSize}>기간 설정</P>
                                    </FlexChild>
                                    <FlexChild>
                                        <HorizontalFlex gap={registerGap2}>
                                            <FlexChild>
                                                <InputText ref={el => (inputs.current[2] = el)} placeHolder={"공지 시작일 입력"} regExp={[textFormat]} />
                                            </FlexChild>
                                            <FlexChild width="auto">
                                                <P>-</P>
                                            </FlexChild>
                                            <FlexChild>
                                                <InputText ref={el => (inputs.current[3] = el)} placeHolder={"공지 종료일 입력"} regExp={[textFormat]} />
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild> */}
                            <FlexChild>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild alignItems="flex-start">
                                        <P size={registerFontSize}>공지 내용</P>
                                    </FlexChild>
                                    <FlexChild alignItems="flex-start">
                                        <CFormInput
                                            placeholder="공지 내용을 입력하세요"
                                            ref={(el) => (inputs.current[5] = el)}
                                            style={{ color: textColor, height: "10vh" }}
                                            defaultValue={notice?.content || ""} 
                                        />
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                            {/* <FlexChild>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild alignItems="flex-start">
                                        <P size={registerFontSize}>노출 페이지</P>
                                    </FlexChild>
                                    <FlexChild alignItems="flex-start">
                                        <CFormSelect onChange={handlePageChange}>
                                            <option value={""}>선택하세요</option>
                                            {expoPage && expoPage.map((page) => (
                                                <option key={page.page} value={page.page}>
                                                    {page.pageExp}
                                                </option>
                                            ))}
                                        </CFormSelect>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild> */}
                        </VerticalFlex>
                    </AdminMobileContentBox>
                </FlexChild>
                <FlexChild height="initial" padding={mainPadd}>
                    <div className={styles.regiBtn} onClick={updateNotice}>
                        <span>수정</span>
                    </div>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default AdminMobileNoticeUpdate;